import {Option} from 'platform/components';

import {defaultTo, isNil} from 'ramda';

import {BillingInformationResponseBody} from '@dms/api/shared';

import {Nullish} from 'shared/web';

export const getOptionsFromBillingInformations = (
  billingInformations: BillingInformationResponseBody[] | Nullish
): Option[] => {
  if (isNil(billingInformations)) {
    return [];
  }

  return billingInformations.map((billingInformation) => ({
    label: defaultTo('', billingInformation.billingName),
    value: billingInformation.id,
  }));
};
